import React, { useState, useMemo, useCallback } from 'react';
import { dateUtils } from '@zipdrug/ui';
import { get } from 'lodash';
import moment from 'moment';
import { reduxForm, SubmissionError } from 'redux-form';
import withCreateDelivery from '../../../hoc/withCreateDelivery';
import withCurrentPharmacy from '../../../hoc/withCurrentPharmacy';
import DeliveryFormConductor from './DeliveryFormConductor';

const OnfleetDashboardURL = 'https://onfleet.com/dashboard';

const buildDateTime = (date, time) => moment(`${date} ${time}`, 'YYYY-MM-DD h:mma').valueOf();

const validate = ({ date }) => {
  const errors = {};
  const momentDate = moment(date).utc();
  if (momentDate.isBefore(dateUtils.startOfDay())) {
    errors.date = "can't be before today";
  }
  if (
    momentDate.isAfter(
      moment()
        .utc()
        .add(100, 'years'),
    )
  ) {
    errors.date = 'must be sooner';
  }
  return errors;
};

const DeliveryForm = props => {
  const [onfleetShortId, setOnfleetShortId] = useState();

  // Memoize initialValues to avoid unnecessary recalculations
  const initialValues = useMemo(
    () => ({
      ...props.initialValues,
      date: moment()
        .utc()
        .format('YYYY-MM-DD'),
      time: {
        max: '10:00pm',
        min: '8:00am',
      },
    }),
    [props.initialValues],
  );

  const onClickOnfleet = useCallback(() => {
    window.open(OnfleetDashboardURL, '_blank');
  }, []);

  const onSubmit = useCallback(
    ({ date, delivery_note, time }) => {
      return props
        .onCreateDelivery({
          address_id: get(props.initialValues, 'id'),
          complete_after: buildDateTime(date, time.min),
          complete_before: buildDateTime(date, time.max),
          note: delivery_note,
        })
        .then(({ data }) => {
          const shortId = get(data, 'createDelivery.data.delivery.short_id');
          setOnfleetShortId(shortId);
        })
        .catch(({ errors }) => {
          throw new SubmissionError(errors);
        });
    },
    [props],
  );

  return (
    <DeliveryFormConductor
      {...props}
      onfleetShortId={onfleetShortId}
      onUpdateShortId={setOnfleetShortId}
      initialValues={initialValues}
      onClickOnfleet={onClickOnfleet}
      onSubmit={onSubmit}
    />
  );
};

const DeliveryFormContainer = reduxForm({
  enableReinitialize: true,
  form: 'orderForm',
  validate,
})(DeliveryForm);

export default withCurrentPharmacy(withCreateDelivery(DeliveryFormContainer));
